<template>
  <div class="print-pdf unit container edit-user-unit-container">
    <div class="pdf-background-img-container">
      <div class="pdf-background-image"></div>
    </div>
    <div class="contentSection pt-16">
      <div v-if="isFetching" class="pa-8 text-center">
        <v-progress-circular indeterminate size="28" class="mr-2" />
        Loading unit…
      </div>
      <div v-else-if="transformedUnit">
        <div class="">
          <div class="close-link" @click="closebuilder">
            <v-icon>arrowleft</v-icon>
            <span class="close-link-text">BACK TO EDIT UNIT</span>
          </div>
        </div>
        <div>
          <div class="unit-meta-container">
            <div class="mb-0 mt-4">
              <h2 id="unit-title" class="base-year">{{ transformedUnit.title }}</h2>
            </div>
            <div class="mb-7 mt-0">
              <span class="font-weight-bold">{{ transformedUnit.subtitle }}</span>
            </div>
          </div>

          <v-row>
            <v-col cols="12">
              <v-divider class="dashed my-10"></v-divider>

              <div id="start" class="font-weight-bold px-10 mb-3">
                UNIT ASSIGNMENTS
              </div>
              <div class="unit-assignments px-10 mb-10">
                <div v-if="transformedUnit.listen">
                  <div class="_flex-this mb-6">
                    <div>
                      <v-checkbox
                        density="compact"
                        hide-details
                        disabled
                        class="mt-0 pt-0"
                      >
                        <template #label>
                          <div class="_flex-this" style="margin-top: 2px">
                            <span class="font-weight-bold">{{ listenLabel }}:</span>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                    <span v-html="transformedUnit.listen" class="label-text"></span>
                  </div>
                </div>
                <div v-if="transformedUnit.complete">
                  <div class="_flex-this mb-6">
                    <div>
                      <v-checkbox
                        density="compact"
                        hide-details
                        disabled
                        class="mt-0 pt-0"
                      >
                        <template #label>
                          <div class="_flex-this" style="margin-top: 2px">
                            <span class="font-weight-bold">{{ completeLabel }}:</span>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                    <span v-html="transformedUnit.complete" class="label-text"></span>
                  </div>
                </div>
                <div v-if="transformedUnit.continueLearning">
                  <div class="_flex-this">
                    <div>
                      <v-checkbox
                        density="compact"
                        hide-details
                        disabled
                        class="mt-0 pt-0"
                      >
                        <template #label>
                          <div class="_flex-this" style="margin-top: 2px">
                            <span class="font-weight-bold"
                              >{{ continueLearningLabel }}:</span
                            >
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                    <span
                      v-html="transformedUnit.continueLearning"
                      class="label-text"
                    ></span>
                  </div>
                </div>
              </div>

              <div id="truth" class="break-page-after">
                <div class="flex-container mt-5">
                  <div class="font-weight-bold text-h6 base-year">TRUTH</div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <UserVersesQuotes
                  :content="transformedUnit.truthVersesQuotes"
                  section="truthVersesQuotes"
                />

                <v-divider
                  v-if="
                    Array.isArray(transformedUnit.truthVersesQuotes)
                      ? transformedUnit.truthVersesQuotes.length
                      : !!transformedUnit.truthVersesQuotes
                  "
                  class="dashed"
                />

                <div
                  v-if="transformedUnit.truthInBible"
                  v-html="transformedUnit.truthInBible"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="transformedUnit.truthStudyQuestions"
                  section="truthStudyQuestions"
                />

                <div
                  v-if="transformedUnit.truthBodyContent"
                  v-html="transformedUnit.truthBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>
              </div>

              <div id="equip" class="break-page-after">
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    EQUIPPING
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-if="transformedUnit.equipBodyContent"
                  v-html="transformedUnit.equipBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="transformedUnit.equipStudyQuestions"
                  section="equipStudyQuestions"
                />
              </div>

              <div id="application" class="break-page-after">
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    ACCOUNTABILITY
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-if="transformedUnit.accountBodyContent"
                  v-html="transformedUnit.accountBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>

                <PreviewStudyQuestions
                  :unitbackdoor="unitbackdoor"
                  :content="transformedUnit.accountStudyQuestions"
                  section="accountStudyQuestions"
                />
              </div>

              <div
                v-if="transformedUnit.footnotesBodyContent"
                class="break-page-after"
              >
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    FOOTNOTES
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-html="transformedUnit.footnotesBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>
              </div>

              <div
                v-if="transformedUnit.copyrightBodyContent"
                class="break-page-after"
              >
                <div class="flex-container">
                  <div class="font-weight-bold text-h6 base-year">
                    COPYRIGHT
                  </div>
                  <v-divider
                    class="dashed"
                    style="margin-top: 15px"
                  ></v-divider>
                </div>

                <div
                  v-html="transformedUnit.copyrightBodyContent"
                  class="print-content-container mb-7 mt-3"
                ></div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-else>No Unit to preview.</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import PreviewStudyQuestions from '@/components/utilities/PreviewStudyQuestions'
  import UserVersesQuotes from '@/components/utilities/UserVersesQuotes'
  import { hydratePreviewFromRoute } from '@/helpers/previewBridge'

  export default {
    name: 'PreviewUnit',
    components: {
      PreviewStudyQuestions,
      UserVersesQuotes,
    },
    data() {
      return {
        feedback: null,
        unit: [],
        currentCourse: [],
        unitbackdoor: 0,
        backdoor: 0,
        isFetching: false,
        fetchDelay: 500,
      }
    },
    computed: {
      ...mapState('UserData', ['user']),
      ...mapState('AppData', ['userActiveCourse', 'prevUnit', 'prevUnitId']),
      ...mapGetters('AppData', ['getCourse', 'getActiveCourse']),
      ...mapGetters('UserData', ['getRoles']),
      // Payload is already flattened for ?lang= / draft by previewBridge + store fetch.
      transformedUnit() {
        return this.prevUnit || null
      },
      listenLabel() {
        const unit = this.transformedUnit || this.prevUnit
        return (
          unit && unit.listenLabel
            ? unit.listenLabel
            : 'Listen'
        ).toUpperCase()
      },
      completeLabel() {
        const unit = this.transformedUnit || this.prevUnit
        return (
          unit && unit.completeLabel
            ? unit.completeLabel
            : 'Complete'
        ).toUpperCase()
      },
      continueLearningLabel() {
        const unit = this.transformedUnit || this.prevUnit
        return (
          unit && unit.continueLearningLabel
            ? unit.continueLearningLabel
            : 'Continue'
        ).toUpperCase()
      },
    },
    methods: {
      init() {
        this.unitbackdoor++

        // grab the prevUnit from the store
        // this.prevUnit = this.prevUnit
      },
      closebuilder() {
        window.close()
      },
    },
    async created() {
      this.isFetching = true

      const delay = new Promise((resolve) =>
        setTimeout(resolve, this.fetchDelay)
      )
      const load = hydratePreviewFromRoute({
        route: this.$route,
        store: this.$store,
        type: 'unit',
      })

      await Promise.all([load, delay])
      this.isFetching = false
      this.init()
    },
  }
</script>

<style scoped>
  [v-cloak] {
    display: none;
  }
  #truth :deep(p),
  #equip :deep(p),
  #application :deep(p),
  #mission :deep(p),
  #supplication :deep(p) {
    page-break-inside: avoid;
    break-inside: avoid;
    padding-top: 16px;
    padding-bottom: 12px;
    margin-bottom: 0;
  }

  #truth :deep(img),
  #equip :deep(img),
  #application :deep(img),
  #mission :deep(img),
  #supplication :deep(img) {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .print-content-container,
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .unit.container {
    max-width: 800px;
    margin-left: 10vw;
    margin-right: auto;
  }
  .unit.container .background-img-container {
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .unit.container .pdf-background-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: url(../../assets/mountains_bw.jpg) no-repeat 50% 0;
    background-size: cover;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    /*filter: grayscale(100%) blur(0px);*/
  }
  .v-theme--dark .unit.container .pdf-background-image {
    filter: grayscale(100%) blur(0px) invert(0.85);
  }
  .pdf-background-image-donotuse:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.85);
  }
  .unit .contentSection {
    /* margin-bottom: 50%; */
    /* max-height: 90vh;
    overflow: hidden; */
    position: relative;
  }
  .edit-user-unit-container.blueYear :deep(a) {
    color: #002b45;
  }
  .edit-user-unit-container.redYear :deep(a) {
    color: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(a) {
    color: #024731;
  }
  .edit-user-unit-container :deep(img) {
    max-width: 100%;
  }
  .unit-assignments :deep(p) {
    margin-bottom: 0;
  }
  .unit-assignments .label-text :deep(p + p) {
    margin-top: 0.5rem;
  }
  .unit-assignments :deep(label) {
    text-transform: none;
  }
  .unit-assignments ._flex-this {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
  }
  .unit-assignments ._flex-this > div:first-child {
    flex: 0 0 auto;
  }
  .unit-assignments :deep(.v-checkbox.v-input) {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-inline-end: 0;
    --v-input-control-height: 24px;
  }
  .unit-assignments :deep(.v-checkbox .v-input__control) {
    min-height: 0;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control) {
    min-height: 0;
    align-items: flex-start;
    column-gap: 8px;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control__wrapper),
  .unit-assignments :deep(.v-checkbox .v-selection-control__input) {
    width: 18px;
    height: 18px;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control--density-compact) {
    --v-selection-control-size: 18px;
  }
  .unit-assignments :deep(.v-checkbox .v-label) {
    white-space: nowrap;
    padding-top: 0;
    padding-inline-start: 0;
    line-height: 1.2;
  }
  .unit-assignments :deep(.v-checkbox .font-weight-bold) {
    white-space: nowrap;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled) {
    opacity: 1;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled .v-label) {
    color: rgba(var(--v-theme-on-background), var(--v-high-emphasis-opacity));
    opacity: 1;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled .v-selection-control__input) {
    opacity: var(--v-disabled-opacity);
  }
  .unit-assignments .label-text {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 13px;
    line-height: 1.5;
    padding-top: 0;
  }
  .unit-assignments :deep(.v-input__slot) {
    align-items: start;
  }
  @media only screen and (max-width: 959px) {
    .unit.container {
      max-width: 100%;
      margin-left: 0;
      padding-inline: 16px;
    }
    .unit.container .contentSection {
      padding-top: 64px !important;
    }
    .unit-assignments.px-10,
    #start.px-10 {
      padding-inline: 0 !important;
    }
    .unit-assignments ._flex-this {
      align-items: flex-start;
      gap: 12px;
    }
  }
  @media only screen and (max-width: 599px) {
    .unit.container {
      padding-inline: 12px;
    }
    .unit-assignments ._flex-this {
      gap: 10px;
    }
    .unit-assignments .label-text {
      font-size: 12px;
    }
  }
</style>
